"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.isJoinedOrHoldMember = void 0;
var _constants = require("../resources/rooms/constants");
var isJoinedOrHoldMember = status => status === _constants.USER_IN_ROOM_STATUS.HOLD || status === _constants.USER_IN_ROOM_STATUS.JOINED;
exports.isJoinedOrHoldMember = isJoinedOrHoldMember;